export default __webpack_public_path__ + "static/media/dive_shot9.77af523b.png";